import { useCallback, useMemo } from 'react';
import { useRouteHash } from '@/hooks/useRouteHash';
import { ScrollTo } from './ScrollTo';

interface ScrollToUrlHashProps {
  children: React.ReactNode;
  urlHash: string;
}

export function ScrollToUrlHash(props: ScrollToUrlHashProps) {
  const { children, urlHash } = props;
  const hash = useRouteHash();
  const condition = useMemo(() => hash === urlHash, [hash, urlHash]);
  const onScrollCallback = useCallback(() => {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }, []);

  return (
    <ScrollTo condition={condition} onScroll={onScrollCallback}>
      {children}
    </ScrollTo>
  );
}
